export const CHECKOUT_V2_BASE_PATH = "/v2";

export const CHECKOUT_V2_START_CHECKOUT_USER_PARAMETER = "userId";
export const CHECKOUT_V2_START_CHECKOUT_SUFFIX = `/start-checkout/:${
  CHECKOUT_V2_START_CHECKOUT_USER_PARAMETER
}`;
/** /v2/start-checkout/:userId */
export const CHECKOUT_V2_START_CHECKOUT_PATH = `${
  CHECKOUT_V2_BASE_PATH
}${
  CHECKOUT_V2_START_CHECKOUT_SUFFIX
}`;

export const CHECKOUT_PRICE_ESTIMATE_METHOD = "POST";
export const CHECKOUT_PRICE_ESTIMATE_SUFFIX = "price-estimate";
/** POST /price-estimate */
export const CHECKOUT_PRICE_ESTIMATE_PATH = CHECKOUT_PRICE_ESTIMATE_SUFFIX;

export const CHECKOUT_LEGACY_START_CHECKOUT_SUFFIX = "/start-checkout-for-basket";
/** /start-checkout-for-basket */
export const CHECKOUT_LEGACY_START_CHECKOUT_PATH = CHECKOUT_LEGACY_START_CHECKOUT_SUFFIX;

export const CHECKOUT_PAYMENTS_BASE_PATH = "/payments";

export const CHECKOUT_PAYMENTS_BASKET_CONFIRMED_SUFFIX = "/basket-confirmed";
/** /payments/basket-confirmed */
export const CHECKOUT_PAYMENTS_BASKET_CONFIRMED_PATH = `${
  CHECKOUT_PAYMENTS_BASE_PATH
}${
  CHECKOUT_PAYMENTS_BASKET_CONFIRMED_SUFFIX
}`;
